export const SpruceGeneralPhoneNumber = '1-888-665-7535';
